import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useQuery, useMutation } from "react-query";
import { QueryKeys } from "../queryKeys";
import { BasePagingResponse, BaseResponse } from "../_types";

export type GetListUnMatchTransactionRequest = {
  page?: number;
  size?: number;
  orderByDesc?: boolean;
  orderBy?: string;
  startDate?: string;
  endDate?: string;
  orderId?: string;
  cardNumber?: string;
  authCode?: string;
  status?: string;
  transactionType?: string;
  bankCode?: string;
  txnType?: string;
  merchantId?:number;
  paymentFlag?:boolean;
  date?:string
  [key: string]: string | number | boolean | undefined;

};

export type GetListUnMatchTransactionResponse = BasePagingResponse<Array<any>>;

async function getListUnMatchTransaction(   
  data: GetListUnMatchTransactionRequest
): Promise<any> {
  try {
    return (await axiosInstance.post("/Transaction/ListUnMatchTransaction", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetListUnMatchTransaction() {
  return useMutation<GetListUnMatchTransactionResponse, Error, GetListUnMatchTransactionRequest>((variables) =>
    getListUnMatchTransaction(variables)
  );
}


